import type { RatingSystem, SkillLevelTier } from "~/graphql/generated";

// ── Rating system display ─────────────────────────────────────────────────────

export const RATING_SYSTEM_LABEL: Record<RatingSystem, string> = {
  PASS_FAIL: "Pass / Fail",
  NUMERIC: "Numeric",
  LETTER_GRADE: "Letter grade",
  CUSTOM: "Custom",
};

export const RATING_SYSTEM_COLOR: Record<RatingSystem, string> = {
  PASS_FAIL: "bg-success-muted text-success-dark",
  NUMERIC: "bg-abyss-50 text-abyss-600 dark:bg-abyss-900 dark:text-abyss-300",
  LETTER_GRADE: "bg-violet-50 text-violet-600 dark:bg-violet-900 dark:text-violet-300",
  CUSTOM: "bg-muted text-muted-foreground",
};

// ── Level tier display ────────────────────────────────────────────────────────

export const LEVEL_TIER_LABEL: Record<SkillLevelTier, string> = {
  INSHORE: "Inshore",
  COASTAL: "Coastal",
  OFFSHORE: "Offshore",
  OCEAN: "Ocean",
  PROFESSIONAL: "Professional",
};

export const LEVEL_TIER_COLOR: Record<SkillLevelTier, string> = {
  INSHORE: "bg-shallow-50 text-shallow-700 dark:bg-shallow-900 dark:text-shallow-300",
  COASTAL: "bg-abyss-50 text-abyss-600 dark:bg-abyss-900 dark:text-abyss-300",
  OFFSHORE: "bg-violet-50 text-violet-600 dark:bg-violet-900 dark:text-violet-300",
  OCEAN: "bg-signal-50 text-signal-700 dark:bg-signal-900 dark:text-signal-300",
  PROFESSIONAL: "bg-coral-50 text-coral-700 dark:bg-coral-900 dark:text-coral-300",
};

// ── Framework display ─────────────────────────────────────────────────────────

export const FRAMEWORK_COLOR: Record<string, string> = {
  RYA: "bg-abyss-50 text-abyss-600 dark:bg-abyss-900",
  STCW: "bg-coral-50 text-coral-700 dark:bg-coral-900",
  IYT: "bg-violet-50 text-violet-600 dark:bg-violet-900",
  ASA: "bg-shallow-50 text-shallow-700 dark:bg-shallow-900",
};
